import { FileDocumentType } from "@nkr/enums/document-type";
import { IBaseResponse } from "@nkr/models/base-response";
import { IFileDto } from "@nkr/models/file-dto";
import { AuthActionCreators } from "@nkr/store/authorization";
import { downloadFile } from "@nkr/services/download-file";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: IFileDto[],
    loading: boolean,
    error: string,
    download: (file: IFileDto) => Promise<void>,
}

function useDonorFiles(donorId: number, documentType: FileDocumentType): IRetVal {

    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IFileDto[]>([]);

    useEffect(() => {

        setError('');

        const fetchData = async () => {
            setLoading(true);

            const config = {
                url: `${__API__}/donor/${donorId}/donor-files/${documentType}`
            };

            try {
                const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);
                } else {
                    setError('Unable to load data');
                    setList([]);
                }
            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

    }, [donorId, documentType]);

    const download = async (file: IFileDto) => {
        const config = {
            url: `${__API__}/file/stored/${file.fileId}`,
            responseType: 'blob'
        };

        const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));
        downloadFile(response.data, file.fileName, 'application/pdf');
    };

    return { loading, error, list, download };
}

export default useDonorFiles;
